"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockOrderDestinationClient = void 0;
var OrderDestination_1 = require("../models/OrderDestination");
exports.MockOrderDestinationClient = {
    getOneById: function (orderDestinationId) {
        return new Promise(function (resolve) { return resolve(mockOrderDestination(orderDestinationId)); });
    },
    getAllByLocation: function (locationId) {
        return new Promise(function (resolve) {
            var ods = [mockOrderDestination(locationId), { locationId: locationId, orderDestinationId: "90fdc5ac-7008-4bfb-971d-54a3e06e195a", resourceType: "area", resourceId: "c59178bb-6a30-48a4-bcf4-c9c3a381a4ec" }];
            resolve(ods);
        });
    },
    create: function (odDto) {
        return new Promise(function (resolve) {
            var orderDestination = new OrderDestination_1.OrderDestination({
                orderDestinationId: "e33cef0c-54b0-487e-96bd-cca4d73b934b",
                locationId: odDto.locationId,
                resourceType: odDto.resourceType,
                resourceId: odDto.resourceId,
                resourceReference: odDto.resourceReference
            });
            resolve(orderDestination);
        });
    }
};
var mockOrderDestination = function (locationId) { return ({ orderDestinationId: "6c8cba9e-e8fe-4da0-ac78-1addc443b72f", locationId: locationId, resourceType: "area", resourceId: "9969a848-3840-42a8-a0cf-1a8364fa07c8" }); };
